var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-peikan" },
    [
      _vm._l(_vm.pkrs, function (pkr, index) {
        return _c("div", { staticClass: "pkr" }, [
          _c("span", [_vm._v(_vm._s(pkr.pkr))]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(pkr.add_time))]),
          _vm._v(" "),
          _c(
            "span",
            {
              on: {
                click: function ($event) {
                  return _vm.deletePkr(pkr)
                },
              },
            },
            [_vm._v("删除")]
          ),
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "from-item" }, [
        _c("div", { staticClass: "from-control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name",
              },
            ],
            attrs: { type: "text", placeholder: "请输入陪看人姓名" },
            domProps: { value: _vm.name },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.name = $event.target.value
                },
                function ($event) {
                  return _vm.inputChange($event)
                },
              ],
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _vm.list.length > 0
        ? _c(
            "div",
            { staticClass: "list" },
            _vm._l(_vm.list, function (item) {
              return _vm.pkrs.findIndex(function (pkr) {
                return pkr.pkr == item.login_name
              }) == -1
                ? _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "item",
                      on: {
                        click: function ($event) {
                          return _vm.select(item)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "name" }, [
                        _vm._v(_vm._s(item.login_name)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "msg" }, [
                        _vm._v(_vm._s("点击添加")),
                      ]),
                    ]
                  )
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }